import {Alert, AlertDescription, AlertIcon, AlertTitle, Box, Code} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import React from 'react'
import AddToCartCTA, {Skeleton as AddToCartSkeleton} from '../../components/add-to-cart-cta'
import {useProduct} from '@salesforce/commerce-sdk-react'

/**
 * Display add to cart button for a given product ID.
 *
 * @param {string} pid - Product ID
 * @param {string} label - Label for the button
 *
 * @example
 *   <pwa-widget-add-to-cart pid="101001" label="add to cart">
 *     $include(...)$
 *   </pwa-widget-add-to-cart>
 */
const WidgetAddToCart = ({pid, label}) => {
    const {
        data: product,
        isLoading,
        error
    } = useProduct({parameters: {id: pid, allImages: true}}, {enabled: !!pid})

    if (!pid) {
        return <Alert status={'error'}>No product ID provided</Alert>
    }

    if (isLoading) {
        return <AddToCartSkeleton />
    }

    if (error) {
        return (
            <Alert status="error">
                <AlertIcon />
                <Box>
                    <AlertTitle>
                        <span>Something bad happened while loading&nbsp;</span>
                        <Code>{pid}</Code>
                        <span>!</span>
                    </AlertTitle>
                    <AlertDescription>{error.toString()}</AlertDescription>
                </Box>
            </Alert>
        )
    }

    // prevent initial flash of undefined product
    if (!product) {
        return null
    }

    return <AddToCartCTA label={label} product={product} scrollToTop={false} />
}

WidgetAddToCart.propTypes = {
    pid: PropTypes.string,
    label: PropTypes.string
}

export default WidgetAddToCart
